import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import * as documentApi from "../../api/documentApi/documentApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {
  EQDocument,
  documentTypeName,
  initializeDocument,
} from "../../models/serverModels/workOrder/EQDocument";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import DocumentForm from "./DocumentForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {documentSchema} from "../../validation/documentSchema";

const CreateDocument = () => {
  const {state} = useLocation();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EQDocument>,
    Params.Create<EQDocument>
  >({
    api: documentApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Document/List/${state}`);
        queryClient.invalidateQueries("DocumentList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<EQDocument>({
    defaultValues: initializeDocument(),
    resolver: yupResolver(documentSchema),
  });
  const onSubmit: SubmitHandler<EQDocument> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeDocument(), ...data, type: state},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle={documentTypeName[state]} />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DocumentForm subText="파일 등록" />
          <ConfirmButtonGroup
            link={`/Document/List/${state}`}
            cancelText="취소"
            confirmText="추가"
          />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateDocument;
